import { Component, OnInit } from '@angular/core';
import { FilterPipe } from '../pipes/filter.pipe';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";

import { UsuarioService } from '../services/usuario.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { AuthService } from '../services/auth.service';
import Swal from 'sweetalert2';
import { FiltroPipe } from '../pipes/filtro.pipe';
import * as moment from 'moment';




@Component({
	selector: 'app-usuarios',
	templateUrl: './usuarios.component.html',
	styleUrls: ['./usuarios.component.css'],
	animations: [loadingFade, modal, alert]
})
export class UsuariosComponent implements OnInit {
	public loading = false;
	public usuarios = [];
	public clientes = [];
	public unidades = [];
	public perfil_usuario = [];
	//public filtroUsuario;
	public campo_filtro = 'usuario_nome';
	public perfil = this.authSvc.getPerfil();


	public filtro = [];
	public dadosFiltrados = [];
	public formFiltro: FormGroup;
	public showFilter = true;

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;
	

	constructor(
		private usuarioSvc: UsuarioService,
		private authSvc: AuthService,
		private unidadeSvc: UnidadeService,
		private clienteSvc: ClienteService,
		private route: ActivatedRoute,
		private router: Router,	
		private fb: FormBuilder,
		) { }

	ngOnInit() {
		//this.pegaUsuarios();
		this.pegaUsuariosFiltro();
		this.criaFiltro();
	}

	criaFiltro() {
		this.pegaClientes();
		//this.pegaUnidades();
		this.pegaPerfilFiltro()


		this.formFiltro = this.fb.group({
		  cliente_id___cliente: null,
		  unidade_id___unidade: null,
		  usuario_login___login: null,
		  usuario_nome___usuario: null,
		  perfil_id___perfil: '',
		  usuario_status___status: ''
		});


		this.route.params.subscribe( params => {

			if(params.id){
	  
			  let splitF = params.id.split("&");
	  
			  let loCliente_id = null;
			  let loUnidade_id = null;
			  let loLogin = null;
			  let loNome = null;
			  let loPerfil = null;
			  let loStatusU = null;


	  
			  this.showFilter = false;
	  
			  for (var i = 0; i < splitF.length; i++) {
	  
				var loSplitValor = splitF[i].split("=");
	  
				switch(loSplitValor[0]) { 
				  case "cliente_id___cliente": { 
	  
					if(loSplitValor[1] !== "null"){
					  loCliente_id = parseInt(loSplitValor[1]);
					  this.pegaUnidadesFiltro(loSplitValor[1]);
					}
					 break; 
	  
				  } 
				  case "unidade_id___unidade": { 
					if(loSplitValor[1] !== "null"){
					  loUnidade_id = parseInt(loSplitValor[1]);
					}
	  
					break; 
				  }
				  case "usuario_login___login": { 
					if(loSplitValor[1] !== "null"){
						 loLogin = loSplitValor[1];
					}
					 break; 
				  } 
				  case "usuario_nome___usuario": { 
					if(loSplitValor[1] !== "null"){
					  loNome = loSplitValor[1];
					}
					break; 
				  }  
				  case "perfil_id___perfil": { 
					if(loSplitValor[1] !== "null"){
						 loPerfil =  parseInt(loSplitValor[1]);
					}
					 break; 
				  }   
				  case "usuario_status___status": { 
					if(loSplitValor[1] !== "null"){
						 loStatusU =  loSplitValor[1];
					}
					 break; 
				  } 				                                                     
				 }
	  
			  }
			  this.preencheForm({
				cliente_id___cliente: loCliente_id,
				unidade_id___unidade: loUnidade_id,
				usuario_login___login: loLogin,
				usuario_nome___usuario: loNome,
				perfil_id___perfil: loPerfil, 
				usuario_status___status: loStatusU
			  });
			  this.filtra();
	  
			}
	  
		  });

	  }

	preencheForm(dados) {
		this.formFiltro.setValue(dados);
	}

	pegaUnidadesFiltro(cliente_id){
		if(cliente_id){
		  this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), cliente_id).then((data: any) => {
			this.unidades = data;
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
			this.loading = false;
		  });
		}
	  }

	  pegaClientes() {
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
		  this.clientes = data;
		});
	  }
	
	  pegaUnidades() {
		this.unidadeSvc.getUnidadesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
		  this.unidades = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }	  
	
	/*pegaUsuarios() {
		this.usuarios = [];
		this.loading = true;
		/*this.usuarioSvc.getUsuariosPag(this.limit, (this.page - 1) * this.limit).then((data: any[]) => {
			this.usuarios = data;
			this.loading = false;
		});
		this.usuarioSvc.getUsuarios().then((data: any[]) => {
			this.usuarios = data;
			this.count = this.usuarios.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
	}*/


	pegaUsuariosFiltro() {

		this.usuarios = [];
		this.loading = true;


		this.usuarioSvc.getUsuariosFiltroQtd(this.authSvc.getUsuarioId(), this.filtro).then((qtde: any) => {
			this.count = qtde;
	  
			this.usuarioSvc.getUsuariosFiltro(this.authSvc.getUsuarioId(), this.filtro, this.page).then((data: any[]) => {

				/*let dados = [];
				for(let usuario of data){

					let unid = "NaoTem"; 
					if(usuario.unidades != null){
						unid = "Tem";
					} 

				  dados.push({
					clinete: usuario.clientes,
					unidade: 'unidades aqui'
				  });
				}				
				console.log("[Dados]", dados);*/

				this.usuarios = data;
				this.loading = false;
			}).catch((err) => {
				console.log(err);
				this.loading = false;
			});
	  
		  }).catch((err) => {
			this.loading = false;
			console.log(err);
		  });


	}

	primPagina() {
		this.page = 1;
		this.pegaUsuariosFiltro();
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
		this.pegaUsuariosFiltro();
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
		this.pegaUsuariosFiltro();
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
		this.pegaUsuariosFiltro();
	}

	filtra() {

		this.filtro = this.formFiltro.value;
		this.count = new FilterPipe().transform(this.usuarios, "", this.campo_filtro).length;
		this.page = 1;
		this.pegaUsuariosFiltro();
	}

	apagaUsuario(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.usuarioSvc.apagaUsuario(id).then((data) => {
					this.pegaUsuariosFiltro();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	expandPanel() {
		this.showFilter = this.showFilter == true ? false : true;
	  }

	
	onChangeCliente(evento) {
		this.formFiltro.controls.unidade_id___unidade.setValue(null);
		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), evento.cliente_id).then((data: any) => {
		  this.unidades = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }

	  pegaPerfilFiltro() {
		this.usuarioSvc.getPerfis().then((data: any) => {
		  //console.log(data)	
		  this.perfil_usuario = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }

	  onClickLimparCampos(){
		this.criaFiltro();
	  }


	  EditUsuario(usuario_id){

		this.filtro = this.formFiltro.value;
	
		let params = '';
	
		for (let f in this.filtro) {
		  let val = this.filtro[f];
		  if (val) {
			let aux = f.split('___');
			if (aux[1] == 'data_i' || aux[1] == 'data_f')
			  val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
	
			params += (params == '')? '?' : '&';
			params += f + "=" + val;
		  }
		}
	
		this.router.navigate(['home/usuarios/edit/' + usuario_id + params]);
	  }
	
	
	  VerUsuario(usuario_id){
	
		this.filtro = this.formFiltro.value;
	
		let params = '';
	
		for (let f in this.filtro) {
		  let val = this.filtro[f];
		  if (val) {
			let aux = f.split('___');
			if (aux[1] == 'data_i' || aux[1] == 'data_f')
			  val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
	
			params += (params == '')? '?' : '&';
			params += f + "=" + val;
		  }
		}
	
		this.router.navigate(['home/usuarios/edit/' + usuario_id + params + '/ver']);
	  }	  

}
